module.exports = __webpack_public_path__ + "static/media/icon-header-operational.40002813.svg";